
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
Scroller,
LoadMore,
Flexbox,
FlexboxItem,
Divider,
XDialog
},
data(){
return{
type:"",
courselist:[],
show:false,
pageIndex:1,
isBottom:false,
returnUrl:""
}
},
mounted(){

document.getElementById("CourseList").style.height = window.innerHeight * 0.7 +'px';

this.type = this.$route.params.type;
if(this.type=="热点课程"){
this.GetHotlist(this.pageIndex);
}else{
this.GetNewList(this.pageIndex);
}
},
methods:{
jump: function (e) {
this.$router.push(e);
},

JumpVideo: function (url, IDCode) {
this.$router.push({
path: url,
name: url,
params: {
IDCode: IDCode,
level1: this.$route.params.level1,
level2: this.$route.params.level2,
level3: this.$route.params.level3,
}
})
},

cutLogo:function(stringLogo){
return stringLogo
},
onScrollBottom:function(){
if(this.isBottom){
document.getElementById("bottomDiv").style.display = "block";
}else{
if (this.onFetching) {

} else {
this.onFetching = true
this.show = true;
setTimeout(() => {

this.pageIndex += 1;
if(this.type=="热点课程"){
this.GetHotlist(this.pageIndex);
}else{
this.GetNewList(this.pageIndex);
}

this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
this.onFetching = false
this.show = false;
}, 1000)
}

}
},
GetHotlist:function(pageIndex){
this.$tyh.GetHotlist1(pageIndex)
.then((data) => {
if(data.data.Status != 0){
return ;
}
var show_data = new Array();

if(data.data.Data.rows.length == 0){
this.isBottom = true;
}
for(var t in data.data.Data.rows){
var time = this.$tyh.formatSeconds(data.data.Data.rows[t].PlayTime);
var name = data.data.Data.rows[t].Name;
var logo = this.cutLogo(data.data.Data.rows[t].Logo);
if(name.length>40)
{
name=name.substr(0, 40) + "...";
}
var showdatas = {
IDCode:data.data.Data.rows[t].IDCode,
ResCount:data.data.Data.rows[t].ResCount,
Logo:logo,
ViewCount:data.data.Data.rows[t].ViewCount,
Name:name,
PlayTime:time
}
this.courselist.push(showdatas)
}


})
},
GetNewList:function(pageIndex){
this.$tyh.GetNewlist1(pageIndex)
.then((data) => {
if(data.data.Status != 0){
return ;
}
var show_data = new Array();
if(data.data.Data.length == 0){
this.isBottom = true;
}
for(var t in data.data.Data){

var time = this.$tyh.formatSeconds(data.data.Data[t].PlayTime);
var name = data.data.Data[t].Name;
var logo = this.cutLogo(data.data.Data[t].Logo);
if(name.length>40)
{
name=name.substr(0, 40) + ".";
}
var showdatas = {
IDCode:data.data.Data[t].IDCode,
ResCount:data.data.Data[t].ResCount,
Logo:logo,
ViewCount:data.data.Data[t].ViewCount,
Name:name,
PlayTime:time
}
this.courselist.push(showdatas)
}

})
}
},
}



// WEBPACK FOOTER //
// ./src/views/Class/CourseMore.vue